const API_BASE = 'https://api.dev.auxo.dk';

/**
 * Henter en hel samling som et simpelt array (v1).
 * God til små, faste lister som f.eks. anmeldelser eller gallerier.
 */
export async function fetchCMSContent(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/public/content/${collectionName}`);
    if (!res.ok) throw new Error(`Fejl ved hentning af ${collectionName}`);
    return await res.json();
  } catch (err) {
    console.error(`[CMS v1 Error] Kunne ikke hente ${collectionName}:`, err);
    return [];
  }
}

/**
 * Henter en samling med v2-endepunktet (pagineret og filtreret).
 */
export async function fetchCMSContentV2(collectionName, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${API_BASE}/public/v2/content/${collectionName}${query ? `?${query}` : ''}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Fejl ved hentning af v2 ${collectionName}`);
    return await res.json();
  } catch (err) {
    console.error(`[CMS v2 Error] Kunne ikke hente v2 ${collectionName}:`, err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

/**
 * Henter et enkelt element baseret på dets slug.
 */
export async function fetchCMSBySlug(slug, lang = 'da') {
  try {
    const url = `${API_BASE}/public/by-slug/${lang}/${slug}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Fejl ved hentning af slug: ${slug}`);
    return await res.json();
  } catch (err) {
    console.error(`[CMS Slug Error] Kunne ikke hente slug ${slug}:`, err);
    return null;
  }
}
